module.exports = __webpack_public_path__ + "static/img/license.9cd5170c.png";